var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowDownFillRedIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1999 3.33332L2.19989 3.33333C2.0784 3.33371 1.95931 3.36722 1.85544 3.43024C1.75158 3.49327 1.66687 3.58344 1.61043 3.69103C1.55399 3.79862 1.52797 3.91957 1.53516 4.04085C1.54235 4.16213 1.58248 4.27915 1.65123 4.37933L7.65123 13.046C7.89989 13.4053 8.49856 13.4053 8.74789 13.046L14.7479 4.37932C14.8173 4.27936 14.8581 4.16228 14.8656 4.04079C14.8732 3.91931 14.8474 3.79807 14.7909 3.69025C14.7344 3.58243 14.6494 3.49216 14.5453 3.42923C14.4411 3.3663 14.3216 3.33313 14.1999 3.33332Z",
    fill: "#EC2D47"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDownFillRedIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ArrowDownFillRedIcon.27b6ff76.svg";
export { ForwardRef as ReactComponent };